import React from "react";
import { Provider } from 'react-redux';
import store from './store/index';
import ReactDOM from "react-dom/client";
import "./index.scss";
import App from "./App";
import "./i18n";
import reportWebVitals from "./reportWebVitals";
import ErrorBoundary from "./CommonElements/ErrorBoundary";

const Root = () => {
  return (
    <ErrorBoundary>
      <div className="App">
        <Provider store={store}>
          <App />
        </Provider>
      </div>
    </ErrorBoundary>
  );
};

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(<Root />);

// ReactDOM.createRoot(<App />, document.getElementById("root"));

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
